<template>
  <div v-cloak id="customer_info" class="right_col" role="main">
    <el-row :gutter="20">
      <el-col :span="24">
        <h3>乘客會員資料</h3>
        <hr />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form label-width="120px" :model="formLabelAlign">
          <el-form-item label="會員名稱">
            <el-input v-model="formLabelAlign.name" class="form-input" />
          </el-form-item>
          <el-form-item label="聯絡電話">
            <el-select
              v-if="customerId"
              v-model="formLabelAlign.contactPhone"
              :disabled="recentPhones.length < 1"
            >
              <el-option
                v-for="phone in recentPhones"
                :key="phone"
                :label="phone"
                :value="phone"
              ></el-option>
            </el-select>
            <el-input v-else v-model="formLabelAlign.contactPhone" />
          </el-form-item>
          <el-form-item label="來電電話">
            <el-input
              v-model="formLabelAlign.incomingPhone"
              class="form-input"
            />
          </el-form-item>
          <el-form-item label="司機黑名單" v-if="showBlacklist">
            <el-form
              ref="blacklistForm"
              :model="blacklistForm"
              :rules="blacklistRules"
            >
              <div class="blacklist-form-row">
                <div class="blacklist-input-group">
                  <el-form-item prop="inputValue">
                    <el-input
                      v-model="blacklistForm.inputValue"
                      ref="saveTagInput"
                      placeholder="輸入隊編/呼號"
                      style="width: 100%"
                    />
                  </el-form-item>
                </div>
                <div class="blacklist-input-group">
                  <el-form-item prop="inputReason">
                    <el-input
                      v-model="blacklistForm.inputReason"
                      placeholder="設定原因(必填)"
                      style="width: 100%"
                    />
                  </el-form-item>
                </div>
                <div class="blacklist-input-group">
                  <el-select
                    v-model="selectMemo"
                    placeholder="請選擇"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in memoOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
                <div class="blacklist-input-group">
                  <el-button type="primary" @click="handleInputConfirm">
                    送出
                  </el-button>
                </div>
              </div>
            </el-form>
            <span>
              <b>✱ 2025/05/14前建立的黑名單 ， 來源歸類在[乘客設定]</b>
            </span>
            <el-table
              :data="blacklistData"
              style="width: 100%; margin-top: 10px"
            >
              <el-table-column prop="callNumber" label="呼號" />
              <el-table-column prop="reason" label="原因" />
              <el-table-column prop="memo" label="來源" />
              <el-table-column prop="updatedAt" label="編輯時間" />
              <el-table-column prop="manager" label="最後編輯者" />
              <el-table-column label="操作" :min-width="160">
                <template slot-scope="scope">
                  <div
                    style="
                      display: flex;
                      gap: 8px;
                      padding-right: 8px;
                      flex-shrink: 0;
                    "
                  >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleEdit(scope.row)"
                    >
                      編輯
                    </el-button>
                    <el-button
                      type="danger"
                      size="mini"
                      @click="handleDelete(scope.row)"
                    >
                      刪除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form label-width="120px" :model="formLabelAlign">
          <el-form-item label="乘客黑名單">
            <el-select v-model="formLabelAlign.isWarning" placeholder="請選擇">
              <el-option
                v-for="item in warning_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="性別">
            <el-select v-model="formLabelAlign.gender" placeholder="請選擇">
              <el-option
                v-for="item in gender_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="特約商家名稱" v-if="showBlacklist">
            <span v-if="formLabelAlign.storeName !== ''">
              {{ formLabelAlign.storeName }}
            </span>
            <span
              v-else
              @click="directStoreList"
              style="cursor: pointer; text-decoration: underline"
            >
              請到特約商家設定
            </span>
          </el-form-item>
          <el-form-item label="乘客(上車)備註">
            <el-input
              type="textarea"
              class="form-textarea"
              :rows="3"
              v-model="formLabelAlign.commands"
              placeholder="格式: 備註1,備註2,備註3"
            />
          </el-form-item>
          <el-form-item label="客服備註">
            <el-input
              type="textarea"
              class="form-textarea"
              :rows="3"
              v-model="formLabelAlign.serviceCommand"
              placeholder="格式: 備註1,備註2,備註3"
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div
      v-for="(item, idx) in inputAddressList"
      :key="idx"
      style="margin-bottom: 8px"
    >
      <el-form label-width="120px">
        <el-form-item :label="'上車地點' + (idx + 1)">
          <el-row :gutter="8">
            <el-col :span="8">
              <el-input class="long-input" v-model="item.address" />
            </el-col>
            <el-col :span="8">
              <el-input class="gps-input" v-model="item.latlng" />
            </el-col>
            <el-col :span="6">
              <el-button type="danger" @click="clickMapFirst(idx + 1)">
                電子地圖
              </el-button>
              <el-button type="default" @click="clearMap(idx)">清空</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="12">
        <el-form label-width="120px">
          <el-form-item v-if="customerId" label="更新人員">
            <el-input type="text" v-model="updatedMember" disabled />
          </el-form-item>
          <el-form-item v-if="customerId" label="更新時間">
            <el-input type="text" v-model="updatedTime" disabled />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">
              {{ customerId ? '更新' : '新增' }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div
      id="customerModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">乘客地圖</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <CustomerSearch
                ref="customerSearch"
                class="col-md-6"
                :items="addresses"
                @changeAddressStatus="onChange"
                :gps="addressDetail"
                @selected="customerSelected"
                @clearMainAddress="clearMainAddress"
              />
              <button
                class="btn btn-primary"
                type="button"
                name="button"
                @click="confirmAddress"
                style="margin-left: 10px"
              >
                確定儲存
              </button>
            </div>
            <div>搜尋地址: {{ searchLocation.address }}</div>
            <div class="row">
              <google-map
                name="example"
                ref="childMethod"
                :input-latitude="searchLocation.latitude"
                :input-longitude="searchLocation.longitude"
                style="height: 600px"
                :size="size"
                @clickAddress="listenAddressFromMap"
              ></google-map>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="編輯黑名單"
      :visible.sync="editDialogVisible"
      width="400px"
    >
      <el-form :model="editRow" label-width="80px">
        <el-form-item label="呼號">
          <el-input v-model="editRow.callNumber" disabled />
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="editRow.reason" />
        </el-form-item>
        <el-form-item label="來源">
          <el-select v-model="editRow.memo" placeholder="請選擇">
            <el-option label="乘客設定" value="乘客設定" />
            <el-option label="司機拒載" value="司機拒載" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitBlackListEdit">儲存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import GoogleMap from '../mapComponent/Map.vue'
import API from '@/assets/js/libs/API'
import Customer from '@/assets/js/libs/Customer'
import CustomerSearch from '@/components/tool/CustomerAutoComplete'
import { cookies } from '@/utils/cookies'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
const customer = new Customer()
export default {
  components: {
    GoogleMap,
    CustomerSearch,
  },
  name: 'CustomerInfo',
  data() {
    return {
      showBlacklist: false,
      blacklistData: [],
      warning_options: [
        {
          value: true,
          label: '開',
        },
        {
          value: false,
          label: '關',
        },
      ],
      gender_options: [
        {
          value: true,
          label: '男',
        },
        {
          value: false,
          label: '女',
        },
      ],
      formLabelAlign: {
        name: '',
        contactPhone: '',
        incomingPhone: '',
        gender: true,
        // 乘客是否是黑名單的值，如果是true的話電話派車會不給直接派
        isWarning: false,
        storeName: '',
        commands: '',
        serviceCommand: '',
      },
      inputVisible: false,
      inputValue: '',
      inputReason: '',
      selectMemo: '1',
      memoOptions: [
        {
          value: '1',
          label: '乘客設定',
        },
        {
          value: '2',
          label: '司機拒載',
        },
      ],
      show_map_model: false,
      searchLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      inputAddressList: [
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
        { address: null, latlng: null },
      ],
      customerId: null,
      clickNumber: 0,
      updatedMember: '',
      updatedTime: '',
      size: 16,
      blacklist: null,
      addressDetail: [],
      addresses: [],
      autoLocation: {
        latitude: '',
        longitude: '',
      },
      options: [
        { country: '台南市', value: '67000' },
        { country: '台南市', value: '67000' },
        { country: '高雄市', value: '64000' },
        { country: '臺北市', value: '63000' },
        { country: '台北市', value: '63000' },
        { country: '臺中市', value: '66000' },
        { country: '台中市', value: '66000' },
        { country: '桃園市', value: '68000' },
        { country: '新北市', value: '65000' },
        { country: '臺東縣', value: '10014' },
        { country: '台東縣', value: '10014' },
        { country: '彰化縣', value: '10007' },
        { country: '嘉義縣', value: '10010' },
        { country: '嘉義市', value: '10020' },
        { country: '新竹縣', value: '10004' },
        { country: '新竹市', value: '10018' },
        { country: '雲林縣', value: '10009' },
        { country: '基隆市', value: '10017' },
        { country: '苗栗縣', value: '10005' },
        { country: '屏東縣', value: '10013' },
        { country: '南投縣', value: '10008' },
        { country: '花蓮縣', value: '64000' },
        { country: '宜蘭縣', value: '10002' },
        { country: '澎湖縣', value: '10016' },
        { country: '金門縣', value: '09020' },
      ],
      list: [],
      storeId: null,
      clearStoreId: false,
      recentPhones: [],
      blacklistForm: {
        inputValue: '',
        inputReason: '',
      },
      blacklistRules: {
        inputValue: [
          { required: true, message: '請輸入呼號或是原因', trigger: 'blur' },
        ],
        inputReason: [
          { required: true, message: '設定原因(必填)', trigger: 'blur' },
        ],
      },
      editDialogVisible: false,
      editRow: {
        callNumber: '',
        reason: '',
        memo: '',
      },
      editOriginRow: {
        reason: '',
        memo: '',
      },
      originIsWarning: false,
      originServiceCommands: '',
    }
  },
  mounted() {
    const phone = this.$route.query.phone
    const customerId = this.$route.query.id
    this.$refs.childMethod.initialMap()
    this.getCustomerInfo(phone, customerId)
  },
  methods: {
    async searchCustomerInfo(phone) {
      const result = await customer
        .getCustomerList(1, 1, phone)
        .then(({ result }) => {
          return result.customerArray.length === 0
        })
        .catch((e) => {
          console.error('搜尋錯誤:', e)
          return true
        })
      return result
    },
    directStoreList() {
      this.$router.push({ name: 'StoreList' })
    },
    getCustomerInfo(phone, customerId) {
      let url = ''

      if (phone !== undefined) {
        url = `customer/v2/?phone=${phone}`
      }
      if (customerId !== undefined) {
        url = `customer/v2/?id=${customerId}`
      }

      if (url) {
        API.get(url)
          .then((res) => {
            if (res.err === undefined) {
              this.formLabelAlign.incomingPhone = res.result.phone
              if (res.result.gender === 'female') {
                this.formLabelAlign.gender = false
              } else {
                this.formLabelAlign.gender = true
              }
              this.showBlacklist = true
              this.formLabelAlign.isWarning = res.result.isWarning
              // 紀錄原始的isWarning 用於判斷是否要送出使用者紀錄
              this.originIsWarning = res.result.isWarning
              this.customerId = res.result.id

              if (res.result.blacklist && Array.isArray(res.result.blacklist)) {
                this.blacklistData = res.result.blacklist.map((item) => ({
                  callNumber: item.callNumber,
                  reason: item.reason,
                  memo: item.memo === '1' ? '乘客設定' : '司機拒載',
                  updatedAt: item.updated,
                  manager: item.teamManagerName,
                }))
              } else {
                this.blacklistData = []
              }

              this.formLabelAlign.name = res.result.name
              this.formLabelAlign.storeName = res.result.storeName
              this.formLabelAlign.contactPhone =
                res.result.phoneList.primaryPhone ||
                res.result.contactPhone ||
                ''
              if (res.result.phoneList.recentPhones.length) {
                this.recentPhones = res.result.phoneList.recentPhones
              } else if (res.result.contactPhone) {
                this.recentPhones = [res.result.contactPhone]
              } else {
                this.recentPhones = []
              }
              this.formLabelAlign.incomingPhone = res.result.phone
              this.updatedTime = res.result.updatedAt
              this.updatedMember = res.result.modifyMember
              this.storeId = res.result.storeId
              this.parseNote(res.result.commands)
              if (
                res.result.serviceCommands &&
                res.result.serviceCommands !== 'null'
              ) {
                this.parseServiceNote(res.result.serviceCommands)
                // 紀錄原始的客服備註 用於判斷是否要送出使用者紀錄
                this.originServiceCommands = this.formLabelAlign.serviceCommand
              }
              this.parseOnLocation(res.result.getinInformations)
            }
          })
          .catch((e) => {
            console.error('API 錯誤:', e)
          })
      }
    },
    handleInputConfirm() {
      this.$refs.blacklistForm.validate((valid) => {
        if (valid) {
          const payload = {
            customerId: this.customerId,
            callNumber: this.blacklistForm.inputValue,
            reason: this.blacklistForm.inputReason,
            memo: this.selectMemo,
          }

          customer.createCustomerBlackList(payload).then((result) => {
            if (result.success) {
              this.$msg(result.message)
              this.getCustomerInfo(undefined, this.customerId)
              BehaviorRecorder.record(
                '點擊',
                '乘客資料',
                `乘客電話: ${this.formLabelAlign.contactPhone}&&
                 設定黑名單 -
                  ${this.blacklistForm.inputValue},
                  ${this.blacklistForm.inputReason},
                  ${this.selectMemo === '1' ? '乘客設定' : '司機拒載'}`,
              )
              this.clearBlacklistInput()
            } else {
              this.$msg(result.message)
            }
          })
        } else {
          this.$msg('請填寫必填欄位')
          return false
        }
      })
    },
    clearBlacklistInput() {
      this.blacklistForm.inputValue = ''
      this.blacklistForm.inputReason = ''
      this.selectMemo = '1'
      this.$refs.blacklistForm.resetFields()
    },
    handleEdit(row) {
      let memoText = row.memo
      if (memoText === '1') memoText = '乘客設定'
      if (memoText === '2') memoText = '司機拒載'
      this.editRow = {
        callNumber: row.callNumber,
        reason: row.reason,
        memo: memoText,
      }
      this.editOriginRow = {
        reason: row.reason,
        memo: memoText,
      }
      this.editDialogVisible = true
    },
    async handleDelete(row) {
      try {
        await this.$confirm(
          `此操作將永久刪除該黑名單 (${row.callNumber})，是否繼續？`,
          '提示',
          {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )

        const payload = {
          customerId: this.customerId,
          callNumber: row.callNumber,
        }

        const result = await customer.removeCustomerBlackList(payload)
        if (result.success) {
          this.$msg(result.message)
          this.getCustomerInfo(undefined, this.customerId)
          BehaviorRecorder.record(
            '點擊',
            '乘客資料',
            `乘客電話: ${this.formLabelAlign.contactPhone}&&
             刪除黑名單 - ${row.callNumber}`,
          )
        } else {
          this.$msg(result.message)
        }
      } catch (error) {
        this.$message({
          type: 'info',
          message: '已取消刪除',
        })
      }
    },
    changeStore(value) {
      if (value === 'clear') {
        this.clearStoreId = true
      }
    },
    setAutoSearchLocation(val) {
      this.setMarker(val)
    },
    getAddresList(addr) {
      if (!addr) return
      let address = addr.replace(/\(.*?\)/g, '')
      API.get(`searchSimilarAddress?address=${address}`)
        .then((res) => {
          this.addresses = []
          this.addressDetail = []
          if (!res || res.result === 'err' || !res.result) {
            console.log('SimilarAddress-err')
            return
          }
          // 確保 res.result.cityDistrictRoad 存在
          if (
            res.result.cityDistrictRoad &&
            res.result.cityDistrictRoad.length === 1
          ) {
            const { addressArray } = res.result
            if (addressArray && Array.isArray(addressArray)) {
              this.addresses = addressArray.map((item) => item.address)
              this.addressDetail = addressArray.map((item) => ({
                gps: item.gps.coordinates,
                address: item.address,
              }))
            }
          } else if (
            res.result.cityDistrictRoad &&
            Array.isArray(res.result.cityDistrictRoad)
          ) {
            this.addresses = res.result.cityDistrictRoad
          }
        })
        .catch((e) => {
          console.error('搜尋地址失敗:', e)
          this.$msg('網路不穩定請再操作一次')
        })
    },
    clearMainAddress() {
      this.addresses = []
      this.addressDetail = []
    },
    customerSelected(val) {
      if (val.address === null) {
        return
      }
      let value = {
        latitude: val.gps[1],
        longitude: val.gps[0],
        address: val.address,
      }
      this.setAutoSearchLocation(value)
    },
    onChange(value) {
      if (value.includes('||') || value.includes('｜｜')) {
        let intersection = value
          .replace('市', '市 ')
          .replace(/\(.*?\)/g, '')
          .trim()
          .replace(/[ ]/g, '+')
          .replace('||', '+')
          .replace('｜｜', '+')
        let countryCode
        for (let city_i = 0; city_i < this.options.length; city_i++) {
          if (intersection.indexOf(this.options[city_i].country) !== -1) {
            countryCode = this.options[city_i].value
            break
          }
        }
        let roadlist = intersection.split('+')
        let road = roadlist[1] + '+' + roadlist[2]
        API.get(`intersectionInfo/?key=${road}&county_number=${countryCode}`)
          .then((res) => {
            if (res.result === 'err') return
            let arrayIntersection = res.result.intersectionInfo
            let addresses = []
            let addressDetail = []
            for (
              let intersection_i = 0;
              intersection_i < arrayIntersection.length;
              intersection_i++
            ) {
              addresses.push(
                '(' +
                  arrayIntersection[intersection_i].town +
                  ') ' +
                  arrayIntersection[intersection_i].city +
                  arrayIntersection[intersection_i].intersection +
                  '||' +
                  arrayIntersection[intersection_i].road,
              )
              addressDetail.push({
                gps: arrayIntersection[intersection_i].Gps.coordinates,
                address:
                  '(' +
                  arrayIntersection[intersection_i].intersection +
                  ') ' +
                  arrayIntersection[intersection_i].city +
                  arrayIntersection[intersection_i].intersection +
                  '||' +
                  arrayIntersection[intersection_i].road,
              })
            }
            this.addresses = addresses
            this.addressDetail = addressDetail
            return
          })
          .catch((err) => {
            console.log('intersectionInfo', err)
          })
        return
      }

      let address = value.trim().replace(/[ ]/g, '+')
      if (address.indexOf('+') === -1) {
        this.getAddresList(value)
        return
      }
      let intersection = address.replace('市', '市 ').replace(/[ ]/g, '+')
      let countryCode
      for (let city_i = 0; city_i < this.options.length; city_i++) {
        if (intersection.indexOf(this.options[city_i].country) !== -1) {
          countryCode = this.options[city_i].value
          break
        }
      }
      // 交叉路口
      let roadlist = intersection.split('+')
      let road = roadlist[1] + '+' + roadlist[2]
      API.get(`intersectionInfo/?key=${road}&county_number=${countryCode}`)
        .then((res) => {
          if (res.result === 'err') return
          let arrayIntersection = res.result.intersectionInfo
          let addresses = []
          let addressDetail = []
          for (
            let intersection_i = 0;
            intersection_i < arrayIntersection.length;
            intersection_i++
          ) {
            addresses.push(
              '(' +
                arrayIntersection[intersection_i].town +
                ') ' +
                arrayIntersection[intersection_i].intersection +
                '||' +
                arrayIntersection[intersection_i].road,
            )
            addressDetail.push({
              gps: arrayIntersection[intersection_i].Gps.coordinates,
              address:
                '(' +
                arrayIntersection[intersection_i].intersection +
                ') ' +
                arrayIntersection[intersection_i].intersection +
                '||' +
                arrayIntersection[intersection_i].road,
            })
          }
          this.addresses = addresses
          this.addressDetail = addressDetail
        })
        .catch((e) => {
          this.$msg('網路不穩定請再操作一次')
          console.error(e)
        })
    },
    parseOnLocation(location) {
      if (location !== 'null' && location.length > 0) {
        const getinInformation = JSON.parse(location)
        getinInformation.forEach((info, i) => {
          if (i < this.inputAddressList.length) {
            this.inputAddressList[i].address = info.getinInformation.onLocation
            const coords = info.getinInformation.passenger_getin_gps.coordinates
            if (coords[1] !== null) {
              this.inputAddressList[i].latlng = `${coords[1]},${coords[0]}`
            }
          }
        })
      }
    },
    parseNote(note) {
      this.formLabelAlign.commands = ''
      if (note) {
        const notes = JSON.parse(note)
        this.formLabelAlign.commands = notes
          .map((item) => item.command)
          .filter(Boolean)
          .join(',')
      }
    },
    parseServiceNote(serviceNote) {
      this.formLabelAlign.serviceCommand = ''
      if (serviceNote !== 'null') {
        const serviceNotes = JSON.parse(serviceNote)
        this.formLabelAlign.serviceCommand = serviceNotes
          .map((item) => item.serviceCommand)
          .filter(Boolean)
          .join(',')
      }
    },
    clickMap() {
      $('#customerModal').modal('show')
    },
    onCancelEditMapBtnClick() {
      $('#customerModal').modal('hide')
      this.clearMapLocation()
    },
    confirmAddress() {
      if (this.searchLocation.address === null) {
        alert('請選擇地點')
        this.clearMapLocation()
        return
      }
      var idx = this.clickNumber - 1
      if (idx >= 0 && idx < this.inputAddressList.length) {
        this.inputAddressList[idx].address = this.searchLocation.address
        this.inputAddressList[idx].latlng =
          this.searchLocation.latitude + ',' + this.searchLocation.longitude
      }
      $('#customerModal').modal('hide')
      this.clearMapLocation()
    },
    clearMapLocation() {
      this.searchLocation.address = null
      this.searchLocation.latitude = null
      this.searchLocation.longitude = null
      this.clickNumber = 0
    },
    clickMapFirst(val) {
      this.clickNumber = val
      $('#customerModal').modal('show')
      this.show_map_model = true
      // 設定地圖中心點
      const idx = val - 1
      if (idx >= 0 && idx < this.inputAddressList.length) {
        // 設定搜尋框預設值
        if (this.inputAddressList[idx].address) {
          this.$refs.customerSearch.setAddress(
            this.inputAddressList[idx].address,
          )
        } else {
          this.$refs.customerSearch.setAddress('')
        }
        // 設定地圖位置
        if (this.inputAddressList[idx].latlng) {
          const [lat, lng] = this.inputAddressList[idx].latlng.split(',')
          this.$refs.childMethod.setLatLng(parseFloat(lat), parseFloat(lng))
        } else {
          // 使用預設位置
          const lat = parseFloat(cookies.get('GladAddressGps').coordinates[1])
          const lng = parseFloat(cookies.get('GladAddressGps').coordinates[0])
          this.$refs.childMethod.setLatLng(lat, lng)
        }
      }
    },
    clearMap(idx) {
      if (idx >= 0 && idx < this.inputAddressList.length) {
        this.inputAddressList[idx].address = null
        this.inputAddressList[idx].latlng = null
      }
    },
    setGender(value) {
      this.gender = value
    },
    setMarker(value) {
      this.searchLocation.latitude = value.latitude
      this.searchLocation.longitude = value.longitude
      this.searchLocation.address = value.address
      this.$refs.childMethod.setLatLng(value.latitude, value.longitude)
    },
    listenAddressFromMap(value) {
      this.searchLocation.address = value.address
      this.searchLocation.latitude = value.latitude
      this.searchLocation.longitude = value.longitude
    },
    transfer() {
      this.$refs.tranfer.transferData()
    },
    async submit() {
      if (this.phone === -1) {
        alert('電話錯誤')
        return
      }

      if (!this.showBlacklist) {
        //此API原設計給空字串會有所有資料 在這邊使用會有問題所以加防呆
        if (
          this.formLabelAlign.incomingPhone === '' ||
          this.formLabelAlign.incomingPhone === null
        ) {
          return this.$msg('請輸入進線電話')
        }
        const result = await this.searchCustomerInfo(
          this.formLabelAlign.incomingPhone,
        )
        if (!result) {
          return this.$msg('已有此進線電話')
        }
      }

      const customerInfo = {
        id: this.customerId,
        name: this.formLabelAlign.name,
        phone: this.formLabelAlign.incomingPhone,
        gender: this.formLabelAlign.gender,
        isWarning: this.formLabelAlign.isWarning,
        commands: this.formLabelAlign.commands,
        serviceCommand: this.formLabelAlign.serviceCommand,
        event: 'customer',
        ...this.inputAddressList.reduce((acc, item, index) => {
          const num = index + 1
          return {
            ...acc,
            [`onLocation${num}`]: item.address,
            [`onLocationLng${num}`]: item.latlng
              ? item.latlng.split(',')[1]
              : null,
            [`onLocationLat${num}`]: item.latlng
              ? item.latlng.split(',')[0]
              : null,
          }
        }, {}),
      }

      if (
        this.formLabelAlign.contactPhone !== '' &&
        this.formLabelAlign.contactPhone !== null
      ) {
        customerInfo.contactPhone = this.formLabelAlign.contactPhone
        let result

        if (!this.customerId) {
          result = await customer.createCustomer(customerInfo)
        } else {
          result = await customer.updateCustomer(customerInfo)
        }

        if (result.success) {
          this.$msg(result.message)
          this.getCustomerInfo(undefined, result.result.id)
          this.recordIsWarningChange()
          this.recordServiceCommandsChange()
        } else {
          this.$msg(result.message)
        }
      }
    },
    async submitBlackListEdit() {
      // 防呆：若原因與來源都沒變則不送出
      if (
        this.editOriginRow.reason === this.editRow.reason &&
        this.editOriginRow.memo === this.editRow.memo
      ) {
        this.$msg('資料未變更，無需送出')
        return
      }
      let memoValue = this.editRow.memo
      if (memoValue === '乘客設定') memoValue = '1'
      if (memoValue === '司機拒載') memoValue = '2'
      const payload = {
        customerId: this.customerId,
        callNumber: this.editRow.callNumber,
        reason: this.editRow.reason,
        memo: memoValue,
      }
      const result = await customer.updateCustomerBlackList(payload)
      if (result.success) {
        this.$msg(result.message)
        this.getCustomerInfo(undefined, this.customerId)
        this.editDialogVisible = false

        let note = `乘客電話: ${this.formLabelAlign.contactPhone}
               &&編輯黑名單 - ${this.editRow.callNumber}`

        // 只記錄有變動的欄位
        if (this.editOriginRow.reason !== this.editRow.reason) {
          note += `&&(原)原因: ${this.editOriginRow.reason}
                   &&(新)原因: ${this.editRow.reason}`
        }
        if (this.editOriginRow.memo !== this.editRow.memo) {
          note += `&&(原)來源: ${this.editOriginRow.memo}
                   &&(新)來源: ${this.editRow.memo}`
        }
        BehaviorRecorder.record('點擊', '乘客資料', note)
      } else {
        this.$msg(result.message)
      }
    },
    async recordIsWarningChange() {
      if (this.formLabelAlign.isWarning !== this.originIsWarning) {
        BehaviorRecorder.record(
          '點擊',
          '乘客資料',
          `乘客電話: ${this.formLabelAlign.contactPhone}&&
           修改乘客黑名單&&
           (原): ${this.originIsWarning ? '開' : '關'}&&
           (新): ${this.formLabelAlign.isWarning ? '開' : '關'}`,
        )
      }
    },
    async recordServiceCommandsChange() {
      if (this.formLabelAlign.serviceCommand !== this.originServiceCommands) {
        BehaviorRecorder.record(
          '點擊',
          '乘客資料',
          `修改客服備註&&
           (原): ${this.originServiceCommands || '無'}&&
           (新): ${this.formLabelAlign.serviceCommand || '無'}`,
        )
      }
    },
  },
}
</script>

<style scoped>
.form-input {
  width: 33%;
  max-width: 203.4px;
}

.form-textarea {
  width: 66%;
}

.blacklist-form-row {
  display: flex;
  align-items: center;
  margin: 0 -5px;
  width: 100%;
}

.blacklist-input-group {
  flex: 0 0 25%;
  max-width: 25%;
  min-width: 0;
  margin: 0 5px;
  display: flex;
  flex-direction: column;
}

.blacklist-input-group .el-form-item,
.blacklist-input-group .el-form-item__content {
  width: 100% !important;
  min-width: 0;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

.blacklist-input-group .el-input__inner,
.blacklist-input-group .el-select .el-input__inner {
  width: 100% !important;
  min-width: 0;
  box-sizing: border-box;
}

.blacklist-input-group .el-button {
  width: 100px;
  min-width: 0;
  padding: 50 16px;
  box-sizing: border-box;
  display: block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/CustomerInfo.vue